module.exports = __webpack_public_path__ + "img/empresa-esp.61eab187.png";